import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import Header from "../../../content-component/Header"
const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const icon1 = imageBaseUrl + "immersion/Benefitsimg1.svg";
const icon2 = imageBaseUrl + "immersion/Benefitsimg2.svg";
const icon3 = imageBaseUrl + "immersion/Benefitsimg3.svg";

const FlipCardContainer = styled(Box)({
  perspective: "1000px",
  width: 280,
  height: 280,
  margin: "20px",
  position: "relative",
});

const FlipCardInner = styled(Box)(({ isFlipped }) => ({
  position: "relative",
  width: "100%",
  height: "100%",
  textAlign: "center",
  transition: "transform 0.6s",
  transformStyle: "preserve-3d",
  transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  borderRadius: "50%",
  border: "1px solid #c1c1c1",
}));

const FlipCardSide = styled(Box)({
  position: "absolute",
  width: "100%",
  height: "100%",
  backfaceVisibility: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  borderRadius: "50%",
});

const FlipCardFront = styled(FlipCardSide)({
  backgroundColor: "#ffffff",
  color: "black",
});

const FlipCardBack = styled(FlipCardSide)({
  background: "linear-gradient(180deg, #00DFE7, #008C90)",
  color: "white",
  transform: "rotateY(180deg)",
  padding: "20px",
  textAlign: "center",
});

const FlipCardBorder = styled(Box)({
  position: "absolute",
  top: "-3px",
  left: "-3px",
  zIndex: -1,
  padding: "10px",
  width: "calc(100% + 10px)",
  height: "calc(100% + 10px)",
  borderRadius: "50%",
  border: "60px dashed #00999E",
  animation: "rotate 5s linear infinite",
  "@keyframes rotate": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
});

const FlipCard = ({ content, icon, title }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <FlipCardContainer
      onMouseEnter={() => setIsFlipped(true)}
      onMouseLeave={() => setIsFlipped(false)}
      onClick={() => setIsFlipped(!isFlipped)}
    >
      <FlipCardBorder />
      <Box
        sx={{
          zIndex: 1,
          padding: "10px",
          borderRadius: "50%",
          bgcolor: "#effdff",
          height: "284px",
          width: "284px",
        }}
      >
        <FlipCardInner isFlipped={isFlipped}>
          <FlipCardFront>
            <Box>
              <img src={icon} alt="icon" style={{ width: "60px" }} />
            </Box>
            <Typography variant="h6" sx={{ textAlign: "center", padding: "0px 15px", fontWeight: "normal" }}>
              {title}
            </Typography>
          </FlipCardFront>
          <FlipCardBack>
            <Typography variant="body1" sx={{ fontSize: "14px", textAlign: "center", fontWeight: "normal", padding: "0px 10px", lineHeight: "1.5", overflow: "hidden", textOverflow: "ellipsis" }}>
              {content}
            </Typography>
          </FlipCardBack>
        </FlipCardInner>
      </Box>
    </FlipCardContainer>
  );
};

export default function Programmes() {
  const cards = [
    { title: "Dual Degree Programmes", content: " Earn two degrees from two institutions by completing an integrated curriculum.", icon: icon1 },
    { title: "Joint Degree Programmes", content: " Receive a single degree jointly awarded by partnered universities.", icon: icon2 },
    { title: "Twinning Programmes", content: " Complete part of your studies in India and the rest at an international university, gaining global exposure.", icon: icon3 },
  ];

  return (
    <Box sx={{ bgcolor: "#effdff", padding: "40px 0px", display: "flex", flexDirection: "column", alignItems: "center" }}>
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mb: 5 }}>
      <Header content={"What Are These Programmes?"} textAlign={"center"} />
    </Box>
    <Box sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
      {cards.map((card, index) => (
        <FlipCard key={index} content={card.content} icon={card.icon} title={card.title} />
      ))}
    </Box>
  </Box>
  );
}
